<script lang="ts">
	import { createEventDispatcher, onDestroy } from 'svelte';
	import { format } from '../../services/i18n';
	import { Select, Toolbar, Breadcrumbs, IconButton, Input } from '@Shelly/shelly-design-system';
	import AddEditButtons from '../AddEditButtons.svelte';
	import SelectRoomFilter from '../SelectRoomFilter.svelte';
	import { capFirstChar } from '../../helpers/utilities';
	import { roomsActivityLogFilter, roomsGroupsFilterInitialState } from 'src/stores/ui/filters';
	import type { SelectOptionPropsType } from '@Shelly/shelly-design-system';
	export let isEmptyDeviceList,
		type: 'global' | 'group' | 'device' = 'global';
	let searchTimeoutId;

	const dispatch = createEventDispatcher(),
		options: SelectOptionPropsType[] = [
			{ value: 'all', title: $format('type_all') },
			{ value: 'actuators', title: $format('type_actuators') },
			{ value: 'sensors', title: $format('type_sensors') },
			{ value: 'scenes', title: $format('tab_scenes') },
			{ value: 'alarms', title: $format('tab_alarms') },
		],
		onFilterByType = (e: CustomEvent) => {
			dispatch('filterBy', {
				value: e.detail.value,
			});
		},
		onFilterByRoom = (e: CustomEvent) => {
			dispatch('filterByRoom', {
				value: e.detail.value,
			});
		},
		onSearchByName = (e: InputEvent) => {
			clearTimeout(searchTimeoutId);
			searchTimeoutId = setTimeout(() => {
				dispatch('searchByName', {
					value: e.target['value'],
				});
			}, 250);
		},
		onRefresh = () => {
			dispatch('refresh');
		};

	onDestroy(() => {
		roomsActivityLogFilter.set({ ...roomsGroupsFilterInitialState });
	});
</script>

{#if type === 'global'}
	<Toolbar class="mb-m" isSticky>
		<Breadcrumbs
			aria-label={$format('label_filter', { default: 'Filter' })}
			slot="breadcrumbs"
			links={[{ label: $format('label_filter', { default: 'Filter' }) }]}
		/>
		<svelte:fragment slot="leftSide">
			<Select
				icon="fas fa-filter"
				class="width-md-m width-sm-full"
				id="eventlog-type-select"
				aria-label={$format('label_filter_by_type', {
					default: 'Filter by type',
				})}
				value={options[0]}
				{options}
				on:change={onFilterByType}
				disabled={isEmptyDeviceList}
			/>
			<SelectRoomFilter
				disabled={isEmptyDeviceList}
				on:change={onFilterByRoom}
				appliedFilters={$roomsActivityLogFilter}
			/>
			<Input
				class="width-md-m width-sm-full"
				type="text"
				id="eventlog-search-input-1"
				aria-label={$format('label_search_events', {
					default: 'Search events',
				})}
				label={capFirstChar(
					$format('search', {
						default: 'Search',
					}),
				)}
				icon="fas fa-search"
				on:input={onSearchByName}
				disabled={isEmptyDeviceList}
			/>
		</svelte:fragment>

		<svelte:fragment slot="rightSide">
			<IconButton
				icon="fa-solid fa-rotate-right"
				id="eventlog-refresh-btn"
				aria-label={$format('label_refresh_events', {
					default: 'Refresh events',
				})}
				on:click={onRefresh}
				disabled={isEmptyDeviceList}
			/>
			<AddEditButtons hideAddButton hideEditButton />
		</svelte:fragment>
	</Toolbar>
{:else}
	<Toolbar class="mb-m" isSticky>
		<Breadcrumbs
			aria-label={$format('label_filter', { default: 'Filter' })}
			slot="breadcrumbs"
			links={[{ label: capFirstChar($format('search')) }]}
		/>
		<svelte:fragment slot="leftSide">
			<SelectRoomFilter
				disabled={isEmptyDeviceList}
				on:change={onFilterByRoom}
				appliedFilters={$roomsActivityLogFilter}
			/>
			<Input
				class="mr-m width-md-s width-sm-full"
				type="text"
				id="eventlog-search-input-2"
				aria-label={$format('label_search_events', {
					default: 'Search events',
				})}
				label={capFirstChar(
					$format('search', {
						default: 'Search',
					}),
				)}
				icon="fas fa-search"
				on:input={onSearchByName}
				disabled={isEmptyDeviceList}
			/>
		</svelte:fragment>

		<svelte:fragment slot="rightSide">
			<IconButton
				icon="fas fa-sync"
				id="eventlog-sync-btn"
				aria-label={$format('label_sync_events', { default: 'Sync events' })}
				on:click={onRefresh}
				disabled={isEmptyDeviceList}
			/>
			<AddEditButtons hideAddButton hideEditButton />
		</svelte:fragment>
	</Toolbar>
{/if}
